import { DateUtils } from './index';

export const FareUtils = {
    PERCENTAGE: 0.4,
    DEPARTURE: {
        getPrice: ({ cheapestPrice, totalPrice, selectedDeparturePrice, date, segments }) => {
            let value;
            if (DateUtils.compare(segments[0].date, date) === 0 && DateUtils.compare(segments[1].date, date) === 0) {
                value = totalPrice;
            } else if (DateUtils.compare(segments[1].date, date) === 0) {
                value = Math.ceil(totalPrice) - Math.ceil(selectedDeparturePrice*FareUtils.PERCENTAGE);
            } else {
                value = cheapestPrice*FareUtils.PERCENTAGE;
            }
            return value;
        },
    },
    RETURN: {
        getPrice: ({ cheapestPrice, totalPrice, selectedDeparturePrice, date, segments }) => {
            let value;
            if (DateUtils.compare(segments[0].date, date) === 0) {
                value = selectedDeparturePrice*FareUtils.PERCENTAGE;
            } else {
                value = Math.ceil(totalPrice) - Math.ceil(selectedDeparturePrice*FareUtils.PERCENTAGE);
            }
            return value;
        },
    },
};
